import { AdminSession, SessionStatus } from '@airreading/common/data';
import { ReactNode } from 'react';
import { SessionStatusChangeModal } from './session-status-change-modal.js';

interface RestoreSessionsProps {
  sessions: AdminSession[];
  trigger: ReactNode;
  onSuccess?: () => void;
}

export const RestoreSessions = ({ sessions, trigger, onSuccess }: RestoreSessionsProps) => {
  return (
    <SessionStatusChangeModal
      sessions={sessions}
      trigger={trigger}
      targetStatus={SessionStatus.scheduled}
      modalTitle="Are you sure you want to restore the following sessions?"
      noValidSessionsTitle="Sessions restored"
      confirmBtnLabel="Restore sessions"
      description="Sessions will be restored to scheduled status and students will be able to attend again."
      noValidSessionsMessage="These sessions are already restored. Only canceled sessions can be restored."
      invalidSessionsMessage="There {are} {count} {session} that cannot be restored. Only canceled sessions can be restored to scheduled."
      buttonVariant="default"
      onSuccess={onSuccess}
    />
  );
};
